import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Callout from '../lib/Callout';
import { REACT_APP_NETWORK_ID } from '../../config';
import { getXrplNetworkName } from './Constants';
import { isXrplMainnet } from './Helpers';
import { Badge } from 'react-bootstrap';

const IntegrationGuide = () => {
  // return (
  //   <div className="d-none d-md-block">
  //     <Alert variant={'info'}>
  //       Do you work for a Bank or Cryptocurrency Exchange? Its easy to integrate XRPSCAN in your app's workflow. Read our <Alert.Link href="https://docs.xrpscan.com/help/integration-guide" target="_blank">Integration guide &rarr;</Alert.Link>
  //     </Alert>
  //   </div>
  // );
  const NETWORK_NAME = getXrplNetworkName(REACT_APP_NETWORK_ID);

  return (
    <div className="d-sm-block">
      { isXrplMainnet() &&
      <Callout title="NEW" variant="primary">
        <span className='ml-1'>
          Try our new advanced search, especially designed for <strong>AML</strong>, <strong>compliance</strong>, and <strong>risk management</strong> teams.
          <Alert.Link href="https://console.xrpscan.com/" target="_blank" className='ml-1'>View Console &rarr;</Alert.Link>
        </span>
      </Callout>
      }
      {/* Show Testnet notice */}
      { !isXrplMainnet() &&
      <Callout variant="warning">
        <span className='ml-1'>
          <span className='text-uppercase mr-1'><Badge variant="warning">{NETWORK_NAME}</Badge></span>
          You are viewing XRPL {NETWORK_NAME}. Funds, tokens and transactions on this network have <strong>NO VALUE</strong> and are not permanent. It may be reset at any time.
        </span>
      </Callout>
      }
    </div>
  );
}

export default IntegrationGuide;